import {
  WASH_STATUS_ORDER,
  STATUS_LABELS,
} from "../../utils/washBookingStatus";

export const WashStatusProgress = ({ status }: { status: string }) => {
  const currentIndex = WASH_STATUS_ORDER.indexOf(status as any);

  return (
    <div className="flex items-center justify-between mb-6 relative">
      {WASH_STATUS_ORDER.map((step, index) => {
        const isCompleted = index <= currentIndex;

        return (
          <div
            key={step}
            className="flex-1 flex flex-col items-center relative"
          >
            {index !== 0 && (
              <div
                className={`absolute top-3 left-[-50%] w-full h-1 ${
                  isCompleted
                    ? "dark:bg-secondaryTextDark bg-secondaryText"
                    : "bg-gray-300"
                }`}
              />
            )}

            <div
              className={`w-6 h-6 rounded-full z-10 flex items-center justify-center
                ${
                  isCompleted
                    ? "dark:bg-secondaryTextDark bg-secondaryText"
                    : "bg-gray-300"
                }`}
            >
              <div className="w-2 h-2 bg-white rounded-full" />
            </div>

            <span className="text-xs mt-2 text-center">
              {STATUS_LABELS[step]}
            </span>
          </div>
        );
      })}
    </div>
  );
};
